import { unescape } from 'lodash';

import { Icon } from '@/components/icon';

import SheetsIcon from '../../assets/google-sheets@3.png';
import DocsIcon from '../../assets/google-docs@3.png';
import SlidesIcon from '../../assets/google-slides@3.png';
import DriveIcon from '../../assets/google-drive@3.png';

import styles from './reference-block.module.scss';

export interface GoogleDriveReferenceProps {
  url: string;
  content?: string;
  name?: string;
  date: string;
  'mime-type'?: string;
  onOpen?: () => void;
}

const mimeTypeMap: Record<string, string | undefined> = {
  'video/mp4': 'MP4 Video',
  'application/pdf': 'PDF Document',
  'application/vnd.google-apps.document': 'Google Docs Document',
  'application/vnd.google-apps.spreadsheet': 'Google Sheets Spreadsheet',
  'application/vnd.google-apps.presentation': 'Google Slides Presentation',
};
const iconMap: Record<string, string | undefined> = {
  'application/vnd.google-apps.document': DocsIcon,
  'application/vnd.google-apps.spreadsheet': SheetsIcon,
  'application/vnd.google-apps.presentation': SlidesIcon,
};

export const GoogleDriveReference = ({
  url,
  name,
  'mime-type': mimeType,
  onOpen,
}: GoogleDriveReferenceProps) => {
  const fileTypeLabel = mimeTypeMap[mimeType ?? ''] ?? 'Google Drive File';
  const icon = iconMap[mimeType ?? ''] ?? DriveIcon;

  return (
    <div className={styles.gDriveBlock}>
      <div className={styles.icon}>
        <img src={icon} draggable={false} />
      </div>
      <div className={styles.title}>
        {unescape(name)}
        <a
          href={url}
          rel="noopener noreferrer nofollow"
          target="_blank"
          className={styles.iconLink}
          draggable={false}
          onClick={onOpen}>
          <Icon name="ExternalLink" size={16} />
        </a>
      </div>
      <div className={styles.subtitle}>{fileTypeLabel}</div>
    </div>
  );
};
